type ConsentManagement = {
  isConsentManagementEnabled: boolean;
  consentManagementRegions: string[];
};

export function useConsentManagement(): ConsentManagement {
  return {
    isConsentManagementEnabled: true,
    consentManagementRegions: [],
  };
}
